export { default } from '@telexpress_auth/vue-tag-management';
